module.exports = __webpack_public_path__ + "img/banner_gpay.ca78c907.png";